import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "f-w-700" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["placeholder", "value"]
const _hoisted_7 = { class: "col-12" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { usePromotionStore, triggerList } from '@/store/management/promotionStore';
import type { Promotion } from '@/store/management/promotionStore';

import { useI18n } from 'vue-i18n'
import { promotionTriggerLanguage } from '@/core/locales/promotions-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'promotionTrigger',
  setup(__props) {

const { t } = useI18n({
  messages: promotionTriggerLanguage
})

const IndividualDepartment = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/IndividualDepartment.vue'))
const MultiDepartment = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/MultiDepartment.vue'))
const IndividualGroup = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/IndividualGroup.vue'))
const MultiProductGroup = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/MultiProductGroup.vue'))
const IndividualPLU = defineAsyncComponent(() => import('@/components/managementPages/PromotionPage/promotionTrigger/IndividualPLU.vue'))

const promotionStore = usePromotionStore()

const compState = reactive({
    triggerType: '',
})

const activePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const tempActivePromotion = computed(() => {
    return promotionStore.getActivePromotion
})

const activePromotionId = computed(() => {
    return promotionStore.getActivePromotion.basic.id
})

const selectedTriggerDescription = computed(() => {
    return triggerList.find(trigger => trigger.id === compState.triggerType)?.description
})

onMounted(() => {
    if (tempActivePromotion.value?.basic.id) {
        compState.triggerType = tempActivePromotion.value.trigger.selectedTrigger
    }
})

watch(activePromotionId, (newVal) => {
    if (newVal) {
        const promotion = activePromotion.value
        compState.triggerType = promotion.trigger.selectedTrigger
    }
}, { immediate: true });

watch(compState, (newVal) => {
    promotionStore.setActivePromotion({
        ...tempActivePromotion.value,
        trigger: {
            ...tempActivePromotion.value.trigger,
            selectedTrigger: newVal.triggerType
        }
    } as Promotion)
}, { deep: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_unref(t)('SelectTrigger')) + ":", 1)
        ]),
        _withDirectives(_createElementVNode("select", {
          class: "form-select",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.triggerType) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(triggerList), (trigger) => {
            return (_openBlock(), _createElementBlock("option", {
              value: trigger.id
            }, _toDisplayString(trigger.name), 9, _hoisted_5))
          }), 256))
        ], 512), [
          [_vModelSelect, compState.triggerType]
        ]),
        _createElementVNode("textarea", {
          class: "form-control mt-3",
          placeholder: _unref(t)('Description'),
          style: {"resize":"none","height":"10rem"},
          readonly: "",
          value: selectedTriggerDescription.value
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (compState.triggerType === '1')
        ? (_openBlock(), _createBlock(_unref(IndividualDepartment), { key: 0 }))
        : (compState.triggerType === '2')
          ? (_openBlock(), _createBlock(_unref(MultiDepartment), { key: 1 }))
          : (compState.triggerType === '4')
            ? (_openBlock(), _createBlock(_unref(IndividualGroup), { key: 2 }))
            : (compState.triggerType === '5')
              ? (_openBlock(), _createBlock(_unref(MultiProductGroup), { key: 3 }))
              : (compState.triggerType === '6')
                ? (_openBlock(), _createBlock(_unref(IndividualPLU), { key: 4 }))
                : _createCommentVNode("", true)
    ])
  ]))
}
}

})